import styled, { css, keyframes } from 'styled-components';

import { breakpoints } from 'theme';

const g = '#0f241f';
const gm = '#00b8a8';
const gl = '#e1f5ee';
const gp = '#f0faf6';
const t = '#111';
const t2 = '#555';
const t3 = '#999';
const bd = '#e2e8e4';
const sf = '#f8faf9';
const am = '#f5a623';
const amp = '#fff8ed';
const danger = '#e24b4a';

export const PageWrap = styled.div`
  max-width: 1040px;
  margin: 0 auto;
  padding: 32px 24px 80px;
  color: ${t};
  background: ${sf};
  min-height: 100%;

  @media ${breakpoints.downSmPlus} {
    padding: 24px 16px 64px;
  }
`;

export const Breadcrumb = styled.nav`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 13px;
  color: ${t3};
  margin-bottom: 20px;
`;

export const BreadcrumbLink = styled.a`
  color: ${t3};
  text-decoration: none;
  &:hover {
    color: ${g};
  }
`;

export const BreadcrumbSep = styled.span`
  font-size: 11px;
`;

export const BreadcrumbCurrent = styled.span`
  color: ${t};
  font-weight: 700;
`;

export const TrialBanner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 20px;
  background: ${amp};
  border-left: 4px solid ${am};
  border-radius: 12px;
  margin-bottom: 28px;
  text-align: left;
`;

export const TrialBannerIcon = styled.span`
  flex-shrink: 0;
  font-size: 16px;
  line-height: 1;
  margin-top: 2px;
`;

export const TrialBannerTextBlock = styled.div`
  min-width: 0;
  flex: 1;
  text-align: left;
`;

export const TrialBannerTitle = styled.div`
  font-size: 13px;
  font-weight: 700;
  color: #a06a0a;
`;

export const TrialBannerSub = styled.div`
  font-size: 12px;
  color: #a06a0a;
  opacity: 0.85;
  margin-top: 2px;
  line-height: 1.5;
`;

export const UsageBox = styled.div`
  background: #fff;
  border: 1.5px solid ${bd};
  border-radius: 20px;
  padding: 22px 28px;
  margin-bottom: 28px;
`;

export const UsageBoxHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 18px;
  flex-wrap: wrap;
`;

export const UsageBoxHeaderIntro = styled.div`
  min-width: 0;
  flex: 1;
`;

export const UsageBoxTitle = styled.div`
  font-size: 15px;
  font-weight: 600;
  color: ${t};
  line-height: 1.3;
`;

export const UsageBoxSubtitle = styled.div`
  font-size: 12px;
  color: ${t3};
  margin-top: 2px;
  line-height: 1.45;
`;

export const PillBadge = styled.span`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  background: ${amp};
  color: #a06a0a;
  padding: 4px 12px;
  border-radius: 40px;
  flex-shrink: 0;
`;

export const UsageProBadge = styled.span`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  background: ${gp};
  color: ${g};
  padding: 4px 12px;
  border-radius: 40px;
  border: 1.5px solid ${gm};
  flex-shrink: 0;
`;

export const ProActiveBanner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 24px;
  background: ${gp};
  border: 1.5px solid ${gl};
  border-radius: 12px;
  margin-bottom: 28px;
  text-align: left;
`;

export const ProActiveDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${gm};
  flex-shrink: 0;
  margin-top: 6px;
`;

export const ProActiveBannerText = styled.div`
  font-size: 14px;
  color: ${g};
  line-height: 1.45;
  flex: 1;
  min-width: 0;
  text-align: left;

  strong {
    font-weight: 700;
  }
`;

export const UsageFitHint = styled.div`
  margin-top: 3px;
  font-size: 11px;
  color: ${gm};
  font-weight: 600;
  line-height: 1.35;
`;

export const UsageLimitHint = styled.div`
  margin-top: 3px;
  font-size: 11px;
  color: ${danger};
  font-weight: 600;
  line-height: 1.35;
`;

export const UsageMutedHint = styled.div`
  margin-top: 3px;
  font-size: 11px;
  color: ${t3};
  line-height: 1.35;
`;

export const CommunitiesNudge = styled.div`
  margin-top: 18px;
  padding: 11px 16px;
  background: ${amp};
  border: 1px solid #f5c842;
  border-radius: 10px;
  font-size: 12px;
  color: #7a5c00;
  line-height: 1.6;

  strong {
    font-weight: 700;
  }
`;

const entPulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(15, 36, 31, 0.4);
  }
  70% {
    box-shadow: 0 0 0 12px rgba(15, 36, 31, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(15, 36, 31, 0);
  }
`;

export const UsageMetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;

  @media ${breakpoints.downMdPlus} {
    grid-template-columns: repeat(2, 1fr);
  }

  @media ${breakpoints.downSmPlus} {
    grid-template-columns: 1fr;
  }
`;

export const UsageMetricBlock = styled.div``;

export const UsageMetricTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 6px;
  gap: 8px;
`;

export const UsageMetricIcon = styled.span`
  flex-shrink: 0;
  font-size: 13px;
  line-height: 1.2;
  margin-top: 1px;
`;

export const UsageMetricLabel = styled.span`
  display: inline-flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: ${t};
`;

export const UsageMetricValue = styled.span<{
  $warn?: boolean;
  $amber?: boolean;
}>`
  font-size: 12px;
  font-weight: 700;
  color: ${({ $warn, $amber }) => ($warn ? danger : $amber ? am : gm)};
`;

export const BarTrack = styled.div`
  width: 100%;
  background: ${gl};
  border-radius: 4px;
  height: 6px;
  overflow: hidden;
`;

export const BarFill = styled.div<{
  $pct: number;
  $warn?: boolean;
  $amber?: boolean;
}>`
  width: ${({ $pct }) => $pct}%;
  height: 100%;
  border-radius: 4px;
  background: ${({ $warn, $amber }) => ($warn ? danger : $amber ? am : gm)};
  transition: width 0.35s ease;
`;

export const UsageHint = styled.div`
  margin-top: 7px;
  font-size: 11px;
  color: ${gm};
  font-weight: 600;
`;

export const NudgeBox = styled.div`
  margin-top: 18px;
  padding: 11px 16px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 10px;
  font-size: 12px;
  color: #7f1d1d;
  line-height: 1.6;
`;

export const PageHeader = styled.div`
  margin-bottom: 28px;
`;

export const PageTitle = styled.h1`
  font-size: 26px;
  font-weight: 600;
  color: ${t};
  margin: 0 0 4px;
`;

export const PageSubtitle = styled.p`
  font-size: 14px;
  color: ${t2};
  margin: 0;
`;

export const PeriodRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 28px;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
`;

export const PeriodToggle = styled.div`
  display: flex;
  background: ${sf};
  border: 1.5px solid ${bd};
  border-radius: 40px;
  padding: 4px;
  gap: 2px;
`;

export const PeriodBtn = styled.button<{ $active?: boolean }>`
  padding: 7px 20px;
  border-radius: 32px;
  font-size: 13px;
  font-weight: 500;
  border: none;
  background: transparent;
  cursor: pointer;
  color: ${t3};
  transition: all 0.15s;
  ${({ $active }) =>
    $active &&
    css`
      background: #fff;
      color: ${g};
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    `}
`;

export const SaveBadge = styled.span`
  font-size: 12px;
  font-weight: 500;
  background: ${amp};
  color: #a06a0a;
  padding: 5px 12px;
  border-radius: 40px;
`;

export const PlansGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.08fr 1fr;
  gap: 20px;
  align-items: start;

  @media ${breakpoints.downMdPlus} {
    grid-template-columns: 1fr;
  }
`;

export const PlanCard = styled.div<{
  $featured?: boolean;
  $isCurrent?: boolean;
  $entHighlight?: boolean;
  $isDowngrade?: boolean;
}>`
  background: ${({ $isCurrent }) => ($isCurrent ? gp : '#fff')};
  border: ${({ $featured, $isCurrent, $isDowngrade }) =>
    $isDowngrade
      ? '1.5px dashed #ccc'
      : $featured
      ? `2px solid ${g}`
      : $isCurrent
      ? `2px solid ${gm}`
      : `1.5px solid ${bd}`};
  border-radius: 20px;
  padding: 28px;
  display: flex;
  flex-direction: column;
  position: relative;
  transition: box-shadow 0.2s, transform 0.2s;
  box-shadow: ${({ $featured, $isDowngrade }) =>
    $featured && !$isDowngrade ? '0 4px 24px rgba(13, 92, 74, 0.13)' : 'none'};
  ${({ $entHighlight }) =>
    $entHighlight &&
    css`
      border-color: ${g} !important;
      box-shadow: 0 8px 28px rgba(15, 36, 31, 0.18) !important;
    `}

  &:hover {
    ${({ $isCurrent, $entHighlight, $isDowngrade }) =>
      !$isCurrent &&
      !$entHighlight &&
      css`
        box-shadow: ${$isDowngrade
          ? '0 6px 20px rgba(226, 75, 74, 0.08)'
          : '0 8px 28px rgba(13, 92, 74, 0.09)'};
        transform: translateY(-2px);
        ${$isDowngrade &&
        css`
          border-color: ${danger};
        `}
      `}
  }
`;

export const PopularBadge = styled.div`
  position: absolute;
  top: -13px;
  left: 50%;
  transform: translateX(-50%);
  background: ${g};
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  padding: 4px 16px;
  border-radius: 40px;
  white-space: nowrap;
`;

export const CurrentPlanBadge = styled.div`
  position: absolute;
  top: -13px;
  left: 50%;
  transform: translateX(-50%);
  background: ${gm};
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  padding: 4px 16px;
  border-radius: 40px;
  white-space: nowrap;
`;

export const DeltaUpBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  color: #085041;
  background: ${gl};
  padding: 3px 9px;
  border-radius: 40px;
  margin-bottom: 10px;
`;

export const DeltaDownBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 600;
  color: #9b1c1c;
  background: #fff0f0;
  padding: 3px 9px;
  border-radius: 40px;
  margin-bottom: 10px;
`;

export const PlanCtaDisabled = styled.span`
  width: 100%;
  padding: 12px;
  border-radius: 40px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 6px;
  text-align: center;
  box-sizing: border-box;
  display: block;
  background: ${gp};
  border: 1.5px solid ${gm};
  color: ${gm};
  cursor: default;
`;

export const PlanTier = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: ${t3};
  margin-bottom: 6px;
`;

export const PlanName = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${t};
  margin-bottom: 4px;
`;

export const PlanTagline = styled.div`
  font-size: 13px;
  color: ${t3};
  margin-bottom: 20px;
`;

export const PlanPrice = styled.div`
  font-size: 40px;
  font-weight: 700;
  color: ${t};
  letter-spacing: -1.5px;
  line-height: 1;
`;

export const PlanPriceSup = styled.sup`
  font-size: 20px;
  font-weight: 600;
  vertical-align: top;
  display: inline-block;
  margin-top: 8px;
`;

export const PlanPricePeriod = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${t3};
  letter-spacing: 0;
`;

export const PlanMonthlyEq = styled.div`
  font-size: 12px;
  color: ${t3};
  margin-top: 3px;
  min-height: 18px;
`;

export const SavingsBadge = styled.span`
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  color: #a06a0a;
  background: ${amp};
  padding: 3px 10px;
  border-radius: 40px;
  margin-top: 6px;
  margin-bottom: 4px;
`;

export const SpecRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin: 16px 0 14px;
`;

export const SpecPill = styled.div<{ $active?: boolean; $current?: boolean }>`
  display: flex;
  align-items: center;
  gap: 5px;
  background: ${({ $active, $current }) => ($current ? gp : $active ? gl : sf)};
  border: 1.5px solid
    ${({ $active, $current }) => ($current || $active ? gm : bd)};
  border-radius: 40px;
  padding: 5px 11px;
  font-size: 12px;
  color: ${t2};
  font-weight: 500;
  white-space: nowrap;
`;

export const SpecVal = styled.span<{ $active?: boolean; $current?: boolean }>`
  font-weight: 700;
  color: ${({ $active, $current }) => ($current || $active ? g : t)};
`;

export const Divider = styled.div`
  height: 1px;
  background: ${bd};
  margin: 16px 0;
`;

export const FeatureList = styled.ul`
  list-style: none;
  flex: 1;
  margin: 0 0 20px;
  padding: 0;
`;

export const FeatureLi = styled.li`
  font-size: 13px;
  color: ${t2};
  padding: 4px 0;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
  line-height: 1.45;
  text-align: left;
`;

export const FiCheck = styled.span`
  flex-shrink: 0;
  color: ${gm};
  font-size: 14px;
  line-height: 1;
  margin-top: 1px;
  width: 14px;
  text-align: center;
`;

export const FeatureItemText = styled.span`
  flex: 1;
  min-width: 0;
  text-align: left;

  strong {
    font-weight: 600;
    color: ${t};
  }
`;

export const PlanCta = styled.a<{
  $variant: 'sec' | 'pri' | 'og';
  $entPulse?: boolean;
}>`
  width: 100%;
  padding: 12px;
  border-radius: 40px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  margin-bottom: 6px;
  text-align: center;
  text-decoration: none;
  box-sizing: border-box;
  display: block;
  ${({ $variant }) =>
    $variant === 'sec' &&
    css`
      background: transparent;
      border: 1.5px solid ${bd};
      color: ${t2};
      &:hover {
        border-color: ${g};
        color: ${g};
      }
    `}
  ${({ $variant }) =>
    $variant === 'pri' &&
    css`
      background: ${g};
      border: none;
      color: #fff;
      &:hover {
        background: #0a1a14;
      }
    `}
  ${({ $variant, $entPulse }) =>
    $variant === 'og' &&
    css`
      background: ${$entPulse ? g : 'transparent'};
      border: ${$entPulse ? 'none' : `1.5px solid ${g}`};
      color: ${$entPulse ? '#fff' : g};
      ${$entPulse &&
      css`
        transform: scale(1.05);
        animation: ${entPulse} 1.5s infinite;
      `}
      &:hover {
        background: ${$entPulse ? '#0a1a14' : gp};
      }
    `}
`;

export const PlanGuarantee = styled.div`
  text-align: center;
  font-size: 12px;
  color: ${t3};
`;

export const PremSliderBlock = styled.div`
  background: ${gp};
  border: 1.5px solid ${gl};
  border-radius: 12px;
  padding: 14px 16px 16px;
  margin: 14px 0 2px;
`;

export const PremSliderHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  gap: 8px;
`;

export const PremSliderLabel = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${g};
  flex: 1;
`;

export const PremMemberDisplay = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: ${g};
  flex-shrink: 0;
`;

/** Thumb diameter; must match slider pseudo-elements and tick alignment math. */
const premSliderThumbPx = 18;

export const PremSlider = styled.input`
  -webkit-appearance: none;
  appearance: none;
  display: block;
  width: 100%;
  height: ${premSliderThumbPx}px;
  border-radius: 4px;
  background: transparent;
  outline: none;
  cursor: pointer;
  margin: 0;

  &::-webkit-slider-runnable-track {
    height: 4px;
    border-radius: 4px;
    background: linear-gradient(
      to right,
      ${g} 0%,
      ${g} var(--slider-fill-pct, 0%),
      ${gl} var(--slider-fill-pct, 0%),
      ${gl} 100%
    );
  }

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: ${premSliderThumbPx}px;
    height: ${premSliderThumbPx}px;
    border-radius: 50%;
    background: ${g};
    cursor: pointer;
    border: 2.5px solid #fff;
    box-shadow: 0 1px 6px rgba(13, 92, 74, 0.35);
    margin-top: calc((${premSliderThumbPx}px - 4px) / -2);
  }

  &::-moz-range-track {
    height: 4px;
    border-radius: 4px;
    background: linear-gradient(
      to right,
      ${g} 0%,
      ${g} var(--slider-fill-pct, 0%),
      ${gl} var(--slider-fill-pct, 0%),
      ${gl} 100%
    );
  }

  &::-moz-range-progress {
    background: transparent;
  }

  &::-moz-range-thumb {
    width: ${premSliderThumbPx}px;
    height: ${premSliderThumbPx}px;
    border-radius: 50%;
    background: ${g};
    cursor: pointer;
    border: 2.5px solid #fff;
    box-shadow: 0 1px 6px rgba(13, 92, 74, 0.35);
    margin-top: calc((${premSliderThumbPx}px - 4px) / -2);
  }
`;

export const PremSliderTicks = styled.div`
  position: relative;
  width: 100%;
  min-height: 14px;
  margin-top: 8px;
  user-select: none;
`;

export const PremTick = styled.span<{
  $active?: boolean;
  $disabled?: boolean;
  $index: number;
  $count: number;
}>`
  position: absolute;
  top: 0;
  left: ${({ $index, $count }) =>
    $count <= 1
      ? '50%'
      : `calc(${premSliderThumbPx / 2}px + (100% - ${premSliderThumbPx}px) * ${
          $index / Math.max(1, $count - 1)
        })`};
  transform: translateX(-50%);
  font-size: 10px;
  line-height: 1.2;
  white-space: nowrap;
  text-align: center;
  color: ${({ $active, $disabled }) =>
    $disabled ? '#d0d5d2' : $active ? g : t3};
  font-weight: ${({ $active, $disabled }) =>
    $disabled ? 400 : $active ? 600 : 400};
`;

export const PremExtraNote = styled.div<{ $visible?: boolean }>`
  font-size: 11px;
  color: #a06a0a;
  background: ${amp};
  border-radius: 6px;
  padding: 5px 10px;
  margin-top: 8px;
  line-height: 1.45;
  display: ${({ $visible }) => ($visible ? 'block' : 'none')};
`;

export const PlanDivider = styled.div`
  background: ${sf};
  border-top: 1.5px solid ${bd};
  border-bottom: 1.5px solid ${bd};
  padding: 32px 24px;
  text-align: center;
  margin: 40px -24px 0;
`;

export const PlanDividerInner = styled.div`
  max-width: 680px;
  margin: 0 auto;
`;

export const PlanDividerTitle = styled.h3`
  font-size: 20px;
  font-weight: 600;
  color: ${t};
  margin: 0 0 6px;
`;

export const PlanDividerText = styled.p`
  font-size: 14px;
  color: ${t2};
  margin: 0 0 20px;
  line-height: 1.6;
`;

export const DividerPills = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
`;

export const DividerPill = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 13px;
  color: ${t2};
  background: #fff;
  border: 1.5px solid ${bd};
  border-radius: 40px;
  padding: 7px 16px;
`;

export const SetupWrap = styled.div`
  padding: 48px 0 48px;
`;

export const SectionLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 28px;
`;

export const SectionNum = styled.div<{ $accent?: boolean }>`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: ${({ $accent }) => ($accent ? am : g)};
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const SectionLabelText = styled.div`
  min-width: 0;
  flex: 1;

  h2 {
    font-size: 21px;
    font-weight: 600;
    margin: 0;
    line-height: 1.25;
  }
  p {
    font-size: 14px;
    color: ${t2};
    margin: 2px 0 0;
    line-height: 1.45;
  }
`;

export const SetupGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
  margin-top: 28px;

  @media ${breakpoints.downMdPlus} {
    grid-template-columns: 1fr;
  }
`;

export const SetupCard = styled.div<{ $featured?: boolean }>`
  background: #fff;
  border: ${({ $featured }) =>
    $featured ? `2px solid ${g}` : `1.5px solid ${bd}`};
  border-radius: 20px;
  padding: 28px;
  position: relative;
  display: flex;
  flex-direction: column;
  transition: box-shadow 0.2s, transform 0.2s;
  box-shadow: ${({ $featured }) =>
    $featured ? '0 4px 24px rgba(13, 92, 74, 0.13)' : 'none'};

  &:hover {
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.07);
    transform: translateY(-2px);
  }
`;

export const SetupPopular = styled.div`
  position: absolute;
  top: -13px;
  left: 32px;
  background: ${g};
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.5px;
  padding: 4px 16px;
  border-radius: 40px;
  white-space: nowrap;
`;

export const SetupTag = styled.span<{ $variant: 'free' | 'new' }>`
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  padding: 2px 10px;
  border-radius: 40px;
  margin-bottom: 6px;
  ${({ $variant }) =>
    $variant === 'free'
      ? css`
          color: ${g};
          background: ${gl};
        `
      : css`
          color: #a06a0a;
          background: ${amp};
        `}
`;

export const SetupName = styled.div`
  font-size: 19px;
  font-weight: 600;
  color: ${t};
  margin-bottom: 4px;
`;

export const SetupTagline = styled.div`
  font-size: 13px;
  color: ${t3};
  margin-bottom: 16px;
  line-height: 1.5;
`;

export const SetupPrice = styled.div`
  font-size: 36px;
  font-weight: 700;
  letter-spacing: -1px;
  color: ${t};
  margin-bottom: 2px;
  line-height: 1;
`;

export const SetupPriceOl = styled.span`
  font-size: 13px;
  font-weight: 400;
  color: ${t3};
  letter-spacing: 0;
`;

export const SetupNote = styled.div`
  font-size: 12px;
  color: #085041;
  background: ${gl};
  border-radius: 8px;
  padding: 9px 12px;
  margin-bottom: 18px;
  line-height: 1.55;
`;

export const SetupSectionLabel = styled.div`
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.8px;
  color: ${t3};
  margin: 14px 0 8px;
`;

export const SetupList = styled.ul`
  list-style: none;
  flex: 1;
  margin: 0 0 20px;
  padding: 0;
`;

export const SetupLiCheck = styled.span`
  flex-shrink: 0;
  color: ${gm};
  font-size: 14px;
  line-height: 1;
  margin-top: 1px;
  width: 14px;
  text-align: center;
`;

export const SetupLiText = styled.span`
  flex: 1;
  min-width: 0;

  strong {
    font-weight: 600;
    color: ${t};
  }
`;

export const SetupLiSub = styled.span`
  display: block;
  font-size: 11px;
  color: ${t3};
  font-weight: 400;
  margin-top: 2px;
`;

export const SetupLi = styled.li`
  font-size: 13px;
  color: ${t2};
  padding: 4px 0;
  display: flex;
  align-items: flex-start;
  gap: 9px;
  line-height: 1.45;
`;

export const SetupCta = styled.a<{ $primary?: boolean }>`
  width: 100%;
  padding: 12px;
  border-radius: 40px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  text-align: center;
  text-decoration: none;
  display: block;
  box-sizing: border-box;
  ${({ $primary }) =>
    $primary
      ? css`
          background: ${g};
          color: #fff;
          border: none;
          &:hover {
            background: #0a1a14;
          }
        `
      : css`
          background: transparent;
          border: 1.5px solid ${bd};
          color: ${t2};
          &:hover {
            border-color: ${g};
            color: ${g};
          }
        `}
`;

export const SetupSub = styled.div`
  text-align: center;
  font-size: 12px;
  color: ${t3};
  margin-top: 8px;
`;

export const CompareWrap = styled.div`
  padding: 0 0 60px;
`;

export const MatrixToggleBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${g};
  background: transparent;
  border: 1.5px solid ${gl};
  border-radius: 40px;
  padding: 9px 20px;
  cursor: pointer;
  transition: all 0.15s;
  margin: 0 auto;

  &:hover {
    background: ${gp};
    border-color: ${gm};
  }
`;

export const MatrixCenter = styled.div`
  text-align: center;
  margin-bottom: 20px;
`;

export const MatrixCollapse = styled.div<{ $open?: boolean }>`
  display: ${({ $open }) => ($open ? 'block' : 'none')};
`;

export const CompareHeader = styled.div`
  text-align: center;
  margin-bottom: 28px;

  h2 {
    font-size: 24px;
    font-weight: 600;
    margin: 0 0 8px;
  }
  p {
    font-size: 14px;
    color: ${t2};
    margin: 0;
  }
`;

export const CompareTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  th {
    font-size: 13px;
    font-weight: 600;
    padding: 14px 16px;
    text-align: left;
    border-bottom: 2px solid ${bd};
  }

  th.hl {
    background: ${gp};
    color: ${g};
  }

  td {
    font-size: 13px;
    padding: 11px 16px;
    border-bottom: 1px solid ${bd};
    color: ${t2};
  }

  td.hl {
    background: ${gp};
  }

  tr:last-child td {
    border-bottom: none;
  }

  tr.cat td {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.8px;
    color: ${t3};
    background: ${sf};
    padding: 10px 16px;
  }
`;

export const Tick = styled.span`
  color: ${gm};
  font-size: 15px;
`;

export const CustomPriceTitle = styled.div`
  font-size: 26px;
  font-weight: 600;
  color: ${t};
  margin: 8px 0 4px;
`;

export const MatrixArrow = styled.span<{ $open?: boolean }>`
  font-size: 10px;
  transition: transform 0.2s;
  display: inline-block;
  transform: ${({ $open }) => ($open ? 'rotate(180deg)' : 'none')};
`;
